import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";

import Formsy from "formsy-react";
import { Input, Checkbox } from "formsy-react-components";
import { Row, Col } from "react-bootstrap";
import DropdownSearch from "../common/DropdownSearch";
import TaskList from "./TaskList";

const ServiceForm = ({
  onAdd,
  service,
  onSave,
  onCancel,
  allTasks,
  departments,
  adding,
  toggleTask,
  saving,
  taxCodes
}) => {
  const formRef = useRef();
  const [canSubmit, setCanSubmit] = useState(false);
  const [inputs, setInputs] = useState({
    code: "",
    description: "",
    department: "",
    status: true,
    tasks: [],
    all_departments: false
  });

  useEffect(() => {
    if (service) {
      setInputs(service);
    }
  }, [service]);

  const add = (model) => {
    onAdd(model);
  };

  const submit = (model) => {
    model.id = service._id;
    onSave(model);
  };

  const cancel = () => {
    onCancel();
  };

  const enableButton = () => {
    setCanSubmit(true);
  };

  const disableButton = () => {
    setCanSubmit(false);
  };

  const onChange = (field, selected) => {
    setInputs((prev) => ({ ...prev, [field]: selected.value }));
  };

  return (
    <Formsy
      ref={formRef}
      className="vertical form"
      onValidSubmit={adding ? add : submit}
      onValid={enableButton}
      onInvalid={disableButton}
    >
      <Row>
        <Col md={4}>
          <Input
            name="code"
            label="Code"
            placeholder="Code"
            value={inputs.code?.toString()}
          />
        </Col>
        <Col md={4}>
          <Input
            required
            formNoValidate
            name="description"
            label="Description"
            placeholder="Description"
            value={inputs.description}
            validations={{ maxLength: 250 }}
            validationErrors={{
              maxLength: "You can not type in more than 250 characters"
            }}
          />
        </Col>

        <Col md={4}>
          <DropdownSearch
            name="department"
            label="Department"
            value={inputs.department}
            data={[
              ...departments.map((department) => ({
                value: department._id,
                label: department.description
              }))
            ]}
            onChange={onChange}
          />
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <DropdownSearch
            name="taxCode"
            label="Tax Code"
            value={inputs.taxCode}
            data={[
              ...taxCodes.map((code) => ({
                value: code._id,
                label: code.code
              }))
            ]}
            onChange={onChange}
          />
        </Col>

        <Col md={4}>
          <DropdownSearch
            name="secondaryTaxCode"
            label="Secondary Tax Code"
            value={inputs.secondaryTaxCode}
            data={[
              ...taxCodes.map((code) => ({
                value: code._id,
                label: code.code
              }))
            ]}
            onChange={onChange}
          />
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <Checkbox
            formNoValidate
            name="status"
            valueLabel="Active"
            value={inputs.status}
          />
        </Col>
        <Col md={4} style={{ display: "flex" }}>
          <Checkbox
            formNoValidate
            name="all_departments"
            valueLabel="Allow For All Departments"
            value={inputs.all_departments}
          />
        </Col>
        {!adding && (
          <Col md={12}>
            <TaskList
              allTasks={allTasks}
              tasks={inputs.tasks}
              toggleTask={toggleTask}
              saving={saving}
            />
          </Col>
        )}
        <Col md={12} className="footer">
          <button
            type="button"
            style={!adding ? { display: "inline" } : { display: "none" }}
            className="btn  btn-cancel"
            onClick={cancel}
          >
            Cancel
          </button>
          <input
            className="btn  btn-success"
            type="submit"
            disabled={!canSubmit || saving}
            value={saving ? "Saving... " : "Save"}
          />
        </Col>
      </Row>
    </Formsy>
  );
};

ServiceForm.propTypes = {
  onSave: PropTypes.func,
  saving: PropTypes.bool,
  service: PropTypes.object,
  onAdd: PropTypes.func,
  onCancel: PropTypes.func,
  toggleTask: PropTypes.func,
  departments: PropTypes.array,
  adding: PropTypes.bool,
  allTasks: PropTypes.array,
  taxCodes: PropTypes.array
};

ServiceForm.defaultProps = {
  adding: false,
  taxCodes: []
};

export default ServiceForm;
